import ReducerCreator from '../registerReducer';
import { buildStoreItem } from '../storeItemBuilder';
import * as VALIDATIONPAGECONFIGURATIONS from './validationPageConfigurations.constants';
import { ValidationPageConfiguration } from '../../models';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

const r = new ReducerCreator<ValidationPageConfiguration>()
    .register<void>(VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_LOAD, (state, payload) => {
        return (Object as any).assign({}, state, { isLoading: true, isLoaded: false });
    })
    .register<ValidationPageConfiguration[]>(VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_LOAD_SUCCESS, (state, payload) => {
        const storeItem = buildStoreItem(payload);
        return storeItem;
    })
    .register<ValidationPageConfiguration[]>(VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_LOAD_ERROR, (state, payload) => {
        // Object.assign<StoreItem<ValidationPageConfiguration>>
        const storeItem = (Object as any).assign({}, state, { isLoading: false, isLoaded: false, hasError: true });
        return storeItem;
    })
    .register<void>(VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_UPDATE, (state, payload) => {
        return (Object as any).assign({}, state, { isLoading: true, isLoaded: false });
    })
    .register<ValidationPageConfiguration[]>(VALIDATIONPAGECONFIGURATIONS.VALIDATION_PAGE_CONFIGURATIONS_UPDATE_SUCCESS, (state, payload) => {
        // Object.assign<StoreItem<ValidationPageConfiguration>>
        const newstate = (Object as any).assign({}, state, { isLoading: false, isLoaded: true, hasError: false });
        // Object.assign<{ [guid: string]: ValidationPageConfiguration }>
        newstate.dictionary = (Object as any).assign({}, newstate.dictionary);
        payload.forEach(vpc => {
            newstate.dictionary[vpc.guid] = vpc;
        });
        return newstate;
    })
    .register<void>(APPLICATION_DISCONNECTED, () => {
        return new StoreItem<ValidationPageConfiguration>();
    });
export function validationPageConfigurationsReducer(state: StoreItem<ValidationPageConfiguration> = new StoreItem<ValidationPageConfiguration>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
